<template>
  <div class="multigraphbox box-block-10" :style="'width:' + nWidth">
    <div class="top boxsizing">
      <div class="top-img-box auto">
        <image-show width="100%" ani height="130px" src="http://img.mp.itc.cn/upload/20170413/7095e85f84d24d1f98180b6a544144f4_th.jpg"></image-show>
        <p class="font14 boxsizing ellipsis">这是标题这是标题这是标题这是标题这是标题这是标题这是标题这是标题这是标题这是标题这是标题这是标题</p>
      </div>
    </div>
    <div class="middle">
      <dl>
        <dt class="ellipsis">这是标题这是标题这是标题这是标题这是标题这是标题</dt>
        <dd><image-show width="70px" height="70px" src="https://bbs-fd.zol-img.com.cn/g5/M00/08/0C/ChMkJ1m6LJKIQdhUAAXEzORqzk0AAgeFwHBg74ABcTk501.jpg"></image-show></dd>
      </dl>
      <dl>
        <dt class="ellipsis">这是标题这是标题这是标题这是标题这是标题这是标题</dt>
        <dd><image-show ani width="70px" height="70px" src="http://img.mp.itc.cn/upload/20170413/7095e85f84d24d1f98180b6a544144f4_th.jpg"></image-show></dd>
      </dl>
      <dl>
        <dt class="ellipsis">这是标题这是标题这是标题这是标题这是标题这是标题</dt>
        <dd><image-show ani width="70px" height="70px" src="https://bbs-fd.zol-img.com.cn/g5/M00/08/0C/ChMkJ1m6LJKIQdhUAAXEzORqzk0AAgeFwHBg74ABcTk501.jpg"></image-show></dd>
      </dl>
    </div>
    <div class="bottom" v-if="control !== undefined">
      <div class="bottombox box-block-10 bottom-delete auto" v-if="control === 'delete'">
        <span>2018-03-06</span>
        <i class="el-icon-delete"></i>
      </div>
      <div class="bottombox box-block-10 bottom-choose auto" v-if="control === 'choose'">
        <span>2018-03-06</span>
        <a href="javascript:;" class="blue">选择</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'multiGraph',
  props: [
    'width',
    'control'
  ],
  data () {
    return {
      nWidth: this.width || '300px'
    }
  },
  methods: {},
  created () {
    console.log(this.control)
  }
}
</script>
<style scoped>
.multigraphbox {
  border: 1px solid #eee;
  border-radius: 5px;
}
.top {
  padding: 10px;
}
.top-img-box {
  border-radius: 5px 5px 0 0;
  position: relative;
}
.top-img-box p {
  width: 100%;
  height: 38px;
  background: rgba(0, 0, 0, .6);
  position: absolute;
  bottom: 0;
  left: 0;
  color: #fff;
  line-height: 38px;
  padding: 0 20px;
  overflow: hidden;
}
.middle {

}
.middle dl {
  border-top: 1px solid #eee;
  padding: 10px;
  position: relative;
  height: auto;
  overflow: hidden;
}
.middle dl dd {
  width: 70px;
  height: 70px;
  overflow: hidden;
  float: right;
  border-radius: 2px;
}
.middle dl dt {
  position: absolute;
  left: 10px;
  top: 10px;
  height: 70px;
  right: 90px;
  line-height: 70px;
  overflow: hidden;
}
.bottom {
  width: 100%;
  border-top: 1px solid #eee;
  height: 56px;
}
.bottombox {
  height: 36px;
  line-height: 36px;
}
.bottom span {
  float: left;
}
.bottom i {
  font-size: 20px;
  margin-top: 8px;
  cursor: pointer;
}
.bottom i, .bottom a {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/common/default/MultiGraph.vue